'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faInstagram, faTiktok, faYoutube, faXTwitter, faFacebook, faReddit,
  faDiscord, faTwitch, faTelegram, faPinterest, faSnapchat, faLinkedin,
  faWhatsapp, faTumblr, faSpotify, faSoundcloud, faWeixin,
  faSteam, faXbox, faPlaystation,
  faPaypal, faStripe, faAmazon, faApplePay, faGooglePay, faBitcoin,
  faGithub, faAws,
  faEbay, faShopify,
  faGoogle, faYahoo,
  faFacebookF,
} from '@fortawesome/free-brands-svg-icons';
import {
  faGamepad, faCoins, faBullhorn, faEnvelope, faFilm, faTrophy,
  faUsers, faShoppingBag, faCode, faTag, faCreditCard, faMoneyBill,
  faStore,
} from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

library.add(
  faInstagram, faTiktok, faYoutube, faXTwitter, faFacebook, faFacebookF,
  faReddit, faDiscord, faTwitch, faTelegram, faPinterest, faSnapchat,
  faLinkedin, faWhatsapp, faTumblr, faSpotify, faSoundcloud, faWeixin,
  faSteam, faXbox, faPlaystation,
  faPaypal, faStripe, faAmazon, faApplePay, faGooglePay, faBitcoin,
  faGithub, faAws,
  faEbay, faShopify,
  faGoogle, faYahoo,
  faGamepad, faCoins, faBullhorn, faEnvelope, faFilm, faTrophy,
  faUsers, faShoppingBag, faCode, faTag, faCreditCard, faMoneyBill, faStore,
);

const PLATFORM_ICON_MAP: Record<string, IconDefinition> = {
  // Social Media
  instagram: faInstagram,
  tiktok: faTiktok,
  youtube: faYoutube,
  'twitter-x': faXTwitter,
  facebook: faFacebook,
  reddit: faReddit,
  discord: faDiscord,
  twitch: faTwitch,
  telegram: faTelegram,
  pinterest: faPinterest,
  snapchat: faSnapchat,
  linkedin: faLinkedin,
  whatsapp: faWhatsapp,
  tumblr: faTumblr,
  spotify: faSpotify,
  soundcloud: faSoundcloud,
  wechat: faWeixin,
  fameswap: faUsers,
  nextdoor: faUsers,
  quora: faUsers,

  // Gaming
  steam: faSteam,
  xbox: faXbox,
  playstation: faPlaystation,
  'epic-games': faGamepad,
  'battle-net': faGamepad,
  valorant: faGamepad,
  fortnite: faGamepad,
  'cs2-csgo': faGamepad,
  'league-of-legends': faGamepad,
  gta: faGamepad,
  roblox: faGamepad,
  osrs: faGamepad,
  runescape: faGamepad,
  'runescape-3': faGamepad,
  minecraft: faGamepad,
  'apex-legends': faGamepad,
  'overwatch-2': faGamepad,
  'world-of-warcraft': faGamepad,
  'genshin-impact': faGamepad,
  'honkai-star-rail': faGamepad,
  'rocket-league': faGamepad,
  pubg: faGamepad,
  'free-fire': faGamepad,
  'clash-of-clans': faGamepad,
  'clash-royale': faGamepad,
  'brawl-stars': faGamepad,
  'pokemon-go': faGamepad,
  '2k': faGamepad,
  'dota-2': faGamepad,
  'rainbow-six-siege': faGamepad,
  faceit: faGamepad,
  csgoroll: faGamepad,
  warframe: faGamepad,
  rust: faGamepad,
  'dead-by-daylight': faGamepad,
  'destiny-2': faGamepad,
  'diablo-4': faGamepad,
  hearthstone: faGamepad,
  'marvel-rivals': faGamepad,
  'blox-fruits': faGamepad,
  'hypixel-skyblock': faGamepad,
  'adopt-me': faGamepad,
  '8-ball-pool': faGamepad,
  dokkan: faGamepad,
  'dragon-ball-legends': faGamepad,
  'elder-scrolls-online': faGamepad,
  'eve-online': faGamepad,
  fisch: faGamepad,
  fragpunk: faGamepad,
  maplestory: faGamepad,
  neopets: faGamepad,
  nikke: faGamepad,
  palworld: faGamepad,
  'path-of-exile': faGamepad,
  'raid-shadow-legends': faGamepad,
  'rise-of-kingdoms': faGamepad,
  'realm-of-the-mad-god': faGamepad,
  'summoners-war': faGamepad,
  tarkov: faGamepad,
  'war-thunder': faGamepad,
  warface: faGamepad,
  wizard101: faGamepad,
  'wuthering-waves': faGamepad,
  'black-desert-online': faGamepad,
  'cod': faGamepad,

  // Financial
  paypal: faPaypal,
  stripe: faStripe,
  'apple-pay': faApplePay,
  binance: faBitcoin,
  coinbase: faBitcoin,
  bitcoin: faBitcoin,
  'cash-app': faMoneyBill,
  wise: faCreditCard,
  skrill: faCreditCard,
  revolut: faCreditCard,
  'crypto-com': faBitcoin,
  bybit: faBitcoin,
  okx: faBitcoin,
  kraken: faBitcoin,
  kucoin: faBitcoin,
  bitget: faBitcoin,
  mexc: faBitcoin,
  advcash: faCreditCard,
  airwallex: faCreditCard,
  alipay: faCreditCard,
  bitpay: faBitcoin,
  blockchain: faBitcoin,
  bluebird: faCreditCard,
  chase: faCreditCard,
  chime: faCreditCard,
  coinpayment: faBitcoin,
  gcash: faCreditCard,
  go2bank: faCreditCard,
  moonpay: faBitcoin,
  neteller: faCreditCard,
  paxful: faBitcoin,
  paxum: faCreditCard,
  payeer: faCreditCard,
  payoneer: faCreditCard,
  paysera: faCreditCard,
  paywithus: faCreditCard,
  'perfect-money': faCreditCard,
  remitly: faCreditCard,
  square: faCreditCard,
  stake: faBitcoin,
  webmoney: faCreditCard,
  zelle: faCreditCard,

  // Advertising & Marketing
  'facebook-ads': faFacebook,
  'facebook-threshold': faFacebook,
  'tiktok-ads': faTiktok,
  'tiktok-shop': faTiktok,
  'google-ads': faGoogle,
  'google-voice': faGoogle,
  'bing-ads': faBullhorn,
  sendgrid: faEnvelope,
  trustpilot: faStore,
  yelp: faStore,
  tripadvisor: faStore,

  // E-commerce
  amazon: faAmazon,
  'amazon-seller': faAmazon,
  ebay: faEbay,
  shopify: faShopify,
  craigslist: faStore,
  target: faStore,
  ticketmaster: faStore,
  walmart: faStore,

  // Developer
  github: faGithub,
  aws: faAws,
  linode: faCode,

  // Mail
  gmail: faGoogle,
  yahoo: faYahoo,
  outlook: faEnvelope,
  hotmail: faEnvelope,
  protonmail: faEnvelope,
  'edu-email': faEnvelope,
  aol: faEnvelope,
  gmx: faEnvelope,
  icloud: faApplePay,
  'mail-ru': faEnvelope,
  rediffmail: faEnvelope,

  // Media
  netflix: faFilm,
  disney: faFilm,
};

const CATEGORY_ICON_MAP: Record<string, IconDefinition> = {
  'social-media': faUsers,
  gaming: faTrophy,
  financial: faCoins,
  'advertising-marketing': faBullhorn,
  'ecommerce-seller': faShoppingBag,
  'developer-infrastructure': faCode,
  mail: faEnvelope,
  media: faFilm,
};

interface PlatformIconProps {
  slug: string;
  size?: number;
  className?: string;
  iconUrl?: string;
}

export default function PlatformIcon({ slug, size = 20, className = '', iconUrl }: PlatformIconProps) {
  if (iconUrl) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img src={iconUrl} alt={slug} style={{ width: size, height: size }} className={`object-contain ${className}`} />
    );
  }
  const icon = PLATFORM_ICON_MAP[slug] ?? faTag;
  return (
    <FontAwesomeIcon icon={icon} style={{ width: size, height: size }} className={className} />
  );
}

export function CategoryIcon({ slug, size = 20, className = '' }: { slug: string; size?: number; className?: string }) {
  const icon = CATEGORY_ICON_MAP[slug] ?? faTag;
  return (
    <FontAwesomeIcon icon={icon} style={{ width: size, height: size }} className={className} />
  );
}
